import drushim_lodash from 'lodash';

const translations = {
  he: {
    titles: {
      topNavbar: [
        {
          name: 'all categories',
          value: 'כל </br> הקטגוריות',
          link: '/categories.aspx',
          innerPage: true
        },
        {
          name: 'lead companies',
          value: 'חברות </br>מובילות',
          link: '/companies.aspx',
          innerPage: true
        },
        {
          name: 'hitech category',
          value: 'דרושים </br>הייטק',
          link: '/דרושים-הייטק/',
          innerPage: true
        },
        {
          name: 'no cv jobs',
          value: 'משרות</br>  ללא קו"ח',
          link: '/משרות-ללא-קורות-חיים/?cv=1',
          innerPage: true
        },

        {
          name: 'cv wizard',
          value: 'קורות חיים</br>בקליק',
          link: '/קורות-חיים/',
          innerPage: true
        },

        {
          name: 'articles lobby',
          value: 'מגזין</br>קריירה',
          link: '/articles/',
          innerPage: true
        },
        {
          name: 'contact us',
          value: 'צור</br>קשר',
          link: '/contactus.aspx',
          innerPage: true
        },
        {
          name: 'smart agent',
          value: 'הסוכנת החכמה',
          link: '/smartalerts.aspx',
          innerPage: true
        }
      ],

      userLoginMenu: {
        name: 'recruitment',
        value: 'גיוס עובדים',
        link: ''
      },

      userLoggedinMenu: [
        {
          name: 'my jobs',
          value: 'משרות מותאמות עבורי',
          link: '/personal/myboard.aspx'
        },
        {
          name: 'cv files',
          value: 'קבצי קורות חיים',
          link: '/personal/cvfiles.aspx'
        },
        {
          name: 'favorites',
          value: 'המשרות שאהבתי',
          link: '/myjobs.aspx'
        },
        {
          name: 'sent cv',
          value: 'משרות שהגשתי אליהן מועמדות',
          link: '/personal/history.aspx'
        },
        {
          name: 'smart agent',
          value: 'סוכן חכם',
          link: '/personal/smartalerts/'
        },
        {
          name: 'removed jobs',
          value: 'משרות שהסרתי',
          link: '/personal/removedjobs.aspx'
        }
      ],
      topBoard: {
        header: 'החברות המובילות בישראל מחפשות אותך!',
        subHeader: 'אלפי משרות מחכות רק לך',
        popularSearchJobs: {
          title: 'חיפושים פופולריים:',
          hybrid: {
            name: 'משרה היברידית',
            link:
              'jobs/search/%D7%9E%D7%A9%D7%A8%D7%94%20%D7%94%D7%99%D7%91%D7%A8%D7%99%D7%93%D7%99%D7%AA/?ssaen=1'
          },
          parent: {
            name: 'עבודה מהבית',
            link: 'jobs/search/עבודה מהבית/?ssaen=1'
          },

          soldier: {
            name: ' חיילים משוחררים',
            link: 'jobs/search/חיילים משוחררים/?ssaen=1'
          },
          temp: {
            name: 'משרה זמנית',
            link: 'jobs/search/משרה%20זמנית/?ssaen=1'
          }
        }
      },
      articlesTips: {
        header: 'טיפים לקריירה ומציאת עבודה',
        btn: {
          text: 'לכל הטיפים',
          link: '/articles/'
        }
      },

      footer: 'דרושים IL אתר הדרושים של ישראל',

      cvWizard: {
        header: 'קורות חיים בקליק',
        subHeader: 'כתיבת קורות חיים  מקצועיים בחינם!',
        introText:
          'מערכת MyCV של דרושים IL תיצור לך קובץ קורות חיים <br> מותאם ומדויק שיבלוט בשוק העבודה'
      },
      contactUs: {
        pageTitle: 'צור קשר',
        nanoTitle: 'האם נוכל לסייע לך?',
        formTitle: 'שלח פנייה',
        sentText: 'פנייתך נשלחה בהצלחה',
        sentLimitText: 'לצערנו מספר הפניות מוגבל, אנא נסו שוב מאוחר יותר'
      },
      errorMessages: {
        WrongPassword: 'סיסמה שגויה',
        EmailsIsIdentical: 'כתובת אימייל זהה לנוכחית',
        emailValidationFailed: 'כתובות המייל אינן תואמות. נא לתקן.'
      },
      categoriesPage: {
        headerTxt: 'כל הקטגוריות',
        subHeaderTxt: 'בחרו מבין מגוון רחב של תחומים, בדרך לתפקיד הבא שלך'
      },
      hitechPage: {
        headerTxt: 'דרושים הייטק',
        subHeaderTxt:
          'עמוד דרושים הייטק מרכז עבור העובדים בהייטק את כל הלינקים הרלוונטיים',
        footerTxtHeader: 'לא מצליחים להחליט על תחום אחד שהכי מתאים לכם?',
        footerTxtSub:
          'הכנסו לכל המשרות ב{{cat}} ומצאו את העבודה הבאה שלכם לפי זמן נסיעה, שנות ניסיון ועוד:)  ',
        btnTxt: `לכל המשרות `
      },
      candidates: {
        cityTitle: 'יישוב',
        emailTitle: 'דוא"ל',
        phoneTitle: 'טלפון',
        birthDateTitle: 'שנת לידה',
        lastJobTitle: 'תפקיד אחרון',
        experienceTitle: 'שנות ניסיון',
        checkboxTitle:
          'מאשר/ת שליחת קורות החיים שלי ע"י המערכת למשרות מתאימות נוספות',
        favJobsTitle: 'משרות שאהבתי',
        showAllFavJobsTitle: 'לכל המשרות שאהבתי',
        showAllSentCvTitle: 'לכל המשרות שהגשתי אליהן מועמדות',
        sentCvTitle: 'מועמדות שהגשתי',
        sendToAllJobsBtn: ' שליחת קו"ח לכל המשרות המסומנות',
        recommendedForYou: ' המלצות במיוחד בשבילך',
        // customJobsTitle: ' משרות מותאמות עבורי ({{num}}) ',

        customJobsTitle: ' משרות מותאמות עבורי ',
        displayAgents: '  הצג משרות לסוכן',
        // jobsBasketTitle: 'משרות שאהבתי ({{num}})',
        jobsBasketTitle: 'משרות שאהבתי',
        emptyBasket: 'סל המשרות ריק',
        historyPageWarning:
          'שים לב! ייתכן ותוכן המשרה נערך ע"י המעסיק מאז שקורות החיים נשלחו.',
        myBoardEmtyTitle:
          'הלוח האישי מתבסס על הגדרות הסוכן החכם. <br />לקבלת משרות מותאמות אישית למייל,',
        myBoardUserGreatings: 'כיף שבאת! הגעת לאזור האישי',
        myBoardEmtyTitleNotRegistered:
          ' כאן מתנהל תהליך חיפוש העבודה שלך.<br/> רוצה לקבל משרות מותאמות במיוחד בשבילך ישירות למייל? הרשם עכשיו',
        cvHistoryTitle: 'משרות שהגשתי אליהן מועמדות ({{num}}) ',
        cvHistoryTitle2: 'עם/ בלי קובץ קו"ח',

        sortByTitle: 'מיון לפי',
        sortNew: 'הזדמנות אחרונה',
        sortClosest: 'הכי קרוב לבית',
        sortPopular: 'הפופולרי ביותר',
        smartAgentTitle: 'הסוכנת החכמה',
        smartAgentSubTitle: `  <span >הסוכנת החכמה באה לעזרה!</span> <br/>

  הגדירו במדויק מה אתם מחפשים והמשרות המתאימות כבר בדרך אליכם <br/>


`,
        smartAgentListSub: `אני כאן בשביל לנהל את הסוכנים החכמים שלכם!   <br/>
תגדירו אותם בקלות - והמשרות המתאימות יגיעו במהירות `,

        switcherText: 'מעוניין לקבל דיוור במסגרת הסוכן החכם',
        smartAlertsBtn: 'שמירת הגדרות הסוכן החכם',
        personalDetails: 'פרטים אישיים',
        closeDetails: 'סגור פרטים'
      },

      company: {
        jobs: 'משרות ב',
        bySubCats: 'לפי תחומים '
      },

      articles: {
        lobby: {
          header: 'מגזין קריירה',
          subHeader:
            'כל מה שצריך לדעת על שוק התעסוקה והקריירה: טיפים, טרנדים וראיונות',
          articleOfTheWeek: 'כתבת השבוע',
          guides: 'הרצאות',
          tools: 'כלים שימושיים',
          showAll: 'הצג הכל',
          extraArticles: 'כתבות נוספות שעשויות לעניין אותך',
          QA: 'שאלות ותשובות'
        },
        readingTimeString: 'זמן קריאה: {{readingTime}} דק`'
      },

      suggestions: {
        systemFound: 'המערכת איתרה עבורך',
        commaFound: 'משרות בקטגוריה',
        andFound: 'ועוד',
        expandSearch: 'האם יעניין אותך להרחיב את החיפוש לאזור ',
        exactMatch: 'או האם ברצונך לחפש את הביטוי המדוייק'
      },

      recommendedUserMsg: 'משרות נוספות שעשויות לעניין אותך',
      noCvNewText: 'חדש',
      smartAgent: {
        thankYouText: 'תודה על שיתוף הפעולה',
        mainTitle: 'הסוכנת החכמה',
        subTitle: `  הרשמו    <span class="font-weight-medium">בחינם</span>    ואני אדאג שהמשרות המתאימות יגיעו אליכם ישירות למייל


        <br />
     אז קדימה, למה אתם מחכים? `,
        step1Text: " נרשמים בצ'יק ",
        step2Text: 'סימון העדפות ומעבר למשרות',
        mainChosenCat: '  קטגוריה ראשית שנבחרה',
        chooseCat: 'בחרו או חפשו קטגוריה ראשית',
        chooseSecCat: 'בחרו קטגוריה נוספת (מומלץ!)',
        chooseArea: ' בחירת תחומים',
        upTo6Area: 'בחרו עד 6 תחומים',
        areas: 'תחומים',
        chosen: 'נבחרו',
        favArea: 'בחירת אזור מועדף',
        allCountries: 'בכל הארץ מבחינתי',
        forwardToJobs: 'סיום ומעבר מיידי למשרות רלוונטיות',
        didYouKnow: 'הידעת?',
        defineMore: 'ניתן להגדיר קריטריונים נוספים לסוכן החכם',
        successMsg: 'הסוכן החכם הוגדר בהצלחה',
        removedMailnigMsg: `
        <span
        class="fit my-2 px-2 py-1 display-18 m-auto bg-primary white--text"
      >  {{email}}  </span>
        הוסרת מרשימת התפוצה . <br/> עצוב לנו אבל אנחנו מבינים. אם תוכל בבקשה להסביר לנו למה, זה אולי יכאב פחות.
        `,

        frequencyConfirmMsg: ` הפעולה הסתיימה בהצלחה!  <br/>
          עדכונים לגבי משרות חדשות יישלחו לכתובת:
             <span
          class="fit my-2 px-2 py-1 display-18 m-auto bg-primary white--text"
        >  {{email}}  </span>
        {{frequency}}
          `
      },
      preferOtherwise: 'מעדיפים אחרת?',
      selectAllCats: 'בחירה מרשימת הקטגוריות המלאה',

      leadingCompanies: 'חברות מובילות באתר',
      leadingCompaniesHitech: 'חברות הייטק מובילות באתר',
      backToOldSite: 'חזרה לאתר הישן',

      confirmationReset: 'אימייל איפוס סיסמה נשלח לכתובת שהוזנה.',

      emailNotExists: 'כתובת האימייל לא קיימת במערכת. ',

      passwordReset:
        'במידה ותוך מספר דקות לא קיבלתם את אימייל איפוס הסיסמה יש לבדוק בתיבת הספאם / דואר זבל בחשבון האימייל שלכם.',
      systemError: 'שגיאת מערכת',
      resetTxt: 'איפוס',
      signUpMail: 'כתובת האימייל איתה נרשמת למערכת:',
      termsRules: 'יש לאשר את תנאי השימוש',
      requiredField: 'שדה חובה',
      invalidEmail: 'כתובת דואר לא חוקית',
      invalidPassword: 'סיסמא לא חוקית',
      phoneFieldLength: 'מספר טלפון לא תקין',

      enterTxt: 'התחברות',

      cvFilterData: {
        Title: {
          Key: 'CvFilterTitle',
          Value: 'משרה ללא קו"ח'
        },
        QueryParamName: 'cv',
        Options: [
          {
            IsSelected: false,
            NumberOfJobs: 0,
            Code: 2,
            NameInHebrew: 'הכל'
          },
          {
            IsSelected: false,
            NumberOfJobs: 0,
            Code: 1,
            NameInHebrew: 'ללא קו"ח'
          }
        ],
        Selected: []
      },

      CV_Popup: {
        emailValidation: 'אימות דוא"ל',
        applyToJob: 'הגשת מועמדות למשרה:',
        chooseCVFile: 'בחירת קו"ח (מתוך 4 קבצים)',
        chooseCVFileSum: 'בחירת קו"ח ',
        chooseFrom: 'מתוך',
        addNewFile: 'הוסף קובץ חדש',
        viewCVFile: 'צפייה בקובץ',
        applientInfo: 'מועמדותך תוגש עם הפרטים הבאים',
        editDetails: 'לעריכה',
        closeEditDetails: 'לסגירה',
        applyWithoutCv: 'פנה/י ללא קו”ח',
        applyCv: 'הגש מועמדות',
        noCvAttention:
          '<b>*שימו לב:</b> למשרה זו אין צורך בקו"ח, אך יש להקפיד על מילוי פרטי יצירת הקשר הנכונים',
        addPersonalLetter: 'הוספת מכתב מקדים (אופציונלי)',
        submitRadioBox:
          'מאשר/ת שליחת קורות החיים שלי ע"י המערכת למשרות מתאימות נוספות',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'דוא"ל',
        password: 'סיסמה',
        newPassword: 'סיסמה חדשה',
        oldPassword: 'סיסמה ישנה',
        phoneNum: 'טלפון נייד',
        phoneNumInvalid: 'מספר טלפון לא תקין ',
        settlement: 'יישוב מגורים',
        lastPosition: 'תפקיד אחרון',
        experience: ' שנות נסיון',
        birthDate: 'שנת לידה',
        saveEdit: 'שמירת שינויים',
        confirmationDialog: 'קורות החיים נשלחו בהצלחה.<br/> מחזיקים לך אצבעות!',
        confirmationDialogNoCV: 'פנייתך נשלחה בהצלחה.<br/> מחזיקים לך אצבעות!',
        alertFailedDialog: 'שליחת קורות החיים נכשלה,<br/> נסה שוב מאוחר יותר',
        isCompleteDetails: '* לא ניתן לשלוח קורות חיים. יש להשלים פרטים חסרים',
        noCvAlertMessage: '  * חובה להעלות לפחות קובץ קורות חיים אחד.',
        existingCVMsg: '* קובץ כבר קיים במערכת',
        CVFileCorrupted:
          'קובץ פגום או מכיל תוכן זדוני. יש למחוק את הקובץ ולהעלות קובץ תקין.',
        CVTooLargeErrorMessage:
          'דרושים IL אינו מאפשר שליחה של קבצי קורות חיים הגדולים מ 500 KB',
        CVFileNotSupported: `קובץ קורות חיים <span class="black--text">{{name}}</span>  אינו נתמך. ניתן לשלוח קובץ קורות חיים מסוג doc, docx, rtf, pdf.`,
        // CVFileNotSupported: 'קובץ קורות חיים  אינו נתמך. {{name}} ניתן לשלוח קובץ קורות חיים מסוג doc, docx, rtf, pdf',
        SendToSimilarJobs:
          'מאשר/ת שליחת קורות חיים שלי ע"י המערכת למשרות מתאימות נוספות',
        successSendAll: 'קורות חיים נשלחו בהצלחה למשרה'
      },

      /**
       * texts for smartAlertsSettings (candidates)
       */
      reduceScopeMsg:
        'שימו לב, סינון לפי היקף משרה עשוי לצמצם משמעותית את מספר המשרות שיישלחו אליכם.',
      reduceExperienceMsg:
        'שימו לב, סינון לפי שנות נסיון עשוי לצמצם משמעותית את מספר המשרות שיישלחו אליכם.',
      minOneSelectionMsg: 'עליך לבחור לפחות אחת מהאפשרויות',
      alertsType: 'העדפות דיוור',

      smartAgentSettings: {
        categories: 'קטגוריות ותחומים',
        zones: 'אזור מועדף',
        scope: 'היקף משרה רצוי',
        experience: 'שנות ניסיון',
        audiencePreference: 'סיווג לקהל יעד מסוים',
        mailingPreference: 'להסרה מהסוכן החכם'
      },

      personalAreaConnect: 'התחברות לאזור האישי',
      personalAreaTitle: 'אזור אישי ',
      recruiterTitle: 'מגייס עובדים',
      lookingForJob: 'מחפש עבודה',
      closeTxt: 'סגור'
    },
    wizard: {
      complete: 'רק רגע... מחפשים לך את משרת החלומות',
      jobType: 'איזה תפקיד אנחנו מחפשים לך?',
      experience: 'כמה שנות ניסיון יש לך בתחום?',
      location: 'מהו יישוב המגורים שלך?',
      preferredLocation: 'באיזה אזור תעדיפו לעבוד?',
      preferredLocationLimit: 'ניתן לבחור יותר מאזור אחד',
      allCountries: 'בכל הארץ מבחינתי',
      travelTime: 'כמה זמן אתה מוכן להעביר בכבישים בדרך לעבודה?',
      pickCategory: 'בחרו קטגוריות רלוונטיות',
      matchedCategories: 'לפי התכונות שסימנת נמצאת מתאים לעבוד בקטגוריות הבאות',
      skills: 'מה המקצוע שרכשת?',
      armyServiceEnded: 'אז השתחררת מהצבא, מה הכיוון שלך?',
      skillsInterest: 'האם אתה מעוניין לעבוד במקצוע שלך?',
      yourQualities: 'ספר לנו מי אתה: אילו תכונות מאפיינות אותך?',
      yourQualitiesLimit: 'ניתן לסמן עד {{number}} תכונות',
      continue: 'המשך',
      upToArea: 'בחרו עד {{number}} תחומים',
      chooseArea: 'הקלד תפקיד...',
      chooseAreas: 'בחירת תחומים',
      chooseMainCategory: 'בחרו קטגוריה ראשית',
      chooseCategoryLabel: 'בחרו או חפשו קטגוריה',
      chooseSecCategory: 'בחרו קטגוריה נוספת (מומלץ!)',
      yes: 'כן',
      no: 'לא',
      releasedFromArmy: 'אז השתחררת מהצבא, מה הכיוון שלך?',
      wondering: 'מתלבט איזו עבודה תתאים לי',
      writingCV: 'כותב קורות חיים וצריך עזרה',
      cv: 'יש לנו פתרון קסמים לכתיבת קורות חיים מנצחים',
      lookingForTips: 'מחפש טיפים למציאת העבודה הראשונה שלי',
      tips: 'קיבצנו לך טיפים מעולים שיסייעו לך במציאת העבודה הראשונה שלך'
    },
    qualities: {
      crowd: 'אוהב לדבר מול קהל',
      kidsPerson: 'מתחבר\\ת לילדים',
      instruction: 'יש לי נסיון בהדרכה',
      commander: 'בעל\\ת רקע פיקודי',
      combat: 'קרבי בנשמה',
      flexibility: 'מחפש גמישות בשעות עבודה',
      peoplePerson: 'אוהב לדבר עם אנשים',
      iceSeller: 'יכול למכור קרח לאסקימוסים',
      maximizeEarnings: 'רוצה להרוויח במקסימום',
      keepPeopleHappy: 'חשוב לי שאנשים יהיו מרוצים',
      serviceWithASmile: 'אוהב לתת שירות עם חיוך',
      helper: 'אוהב לעזור לאנשים',
      moneyForTrip: 'רוצה לעשות כסף לטיול אחרי הצבא',
      physicalWork: 'מעדיף עבודה פיזית קלה מאשר לשבת מול המחשב',
      young: 'מחפש עבודה בסביבה צעירה',
      armyPreferredJob: 'עבודה מועדפת אחרי הצבא',
      easyJob: 'מחפש משרה פשוטה בלי הרבה מאמץ',
      startNow: 'תביאו מה שיש העיקר להתחיל לעבוד'
    },
    selectedNum: 'נבחרו {{number}} תחומים',

    genericPopups: {
      deleteFile: {
        deleteCVFromPersonal:
          'שים לב! פעולה זו תגרום למחיקת הקובץ מכל המשרות אליהן שלחת קובץ זה בעבר. האם אתה רוצה להמשיך?',
        confirm: 'מחק קובץ',
        abort: 'ביטול'
      }
    },

    jobs: {
      jobRankTitle: `עד כמה המשרה מעניינת אותך?`,
      jobRankSubTitle: ` תשובתך תסייע לנו לקרב אותך אל משרת חלומותיך`,
      noActiveJobsFound: `לא נמצאו משרות פעילות עבור
      <span class="primary--text">{{searchTerm}}</span> אנא נסו לשנות את מאפייני החיפוש.`,
      additionalJobs: 'משרות נוספות מומלצות עבורך',
      additionalJobsSun:
        'לפי החיפושים הקודמים שלך וחיפושים דומים של מועמדים אחרים',
      foundAdditionalJobs: 'מצאנו {{ numOfJobs }} משרות שעשויות לעניין אותך',
      foundAdditionalNoCvJobs:
        'מצאנו {{ numOfJobs }} משרות ללא קו"ח שעשויות לעניין אותך',
      jobItem: {
        close: 'X סגירת פרטי המשרה',
        open: 'לצפייה בפרטי המשרה'
      }
    },
    tooltips: {
      addToFavorites: 'להוספה/ הסרה של משרות שאהבת'
    }
  },

  en: {
    titles: {
      leadingCompanies: 'you user No. {{number}}',
      leadingCompaniesHitech: 'חברות הייטק מובילות באתר',
      backToOldSite: 'you user No. {{number}}',
      passwordReset: 'אימייל איפוס סיסמה נשלח לכתובת שהוזנה.'
    }
  }
};

// function t1(key) {  // 'titles.leadingCompanies'
//   return drushim_lodash.get(translations, local+'.'+key, key)
// }
drushim_lodash.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
export function t(key, options = null) {
  // 'titles.leadingCompanies'
  const string = drushim_lodash.get(translations, [local, key].join('.'), key);
  if (options) {
    let compiled = drushim_lodash.template(string);
    return compiled(options);
  }
  return string;
}

// default local
let local = 'he';

export function changeLocal(val) {
  local = val;
}
